import React from "react";
import {fetchCategory, fetchCategoryInfo, fetchCategoryShop} from '@/app/lib/data';
import Link from 'next/link';
import { Circle, CircleCheck, ChevronLeft } from 'lucide-react';

export default function Category({catInfo, allCatSection}) {
    const categoryInfo = catInfo
    const allCategoryShop = allCatSection;

    const CategoryRow = ({ href, label, isActive = false, leadingIcon = null }) => (
        <Link
            href={href}
            className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition-colors ${
                isActive
                    ? 'bg-primary/10 text-primary-600 font-medium'
                    : 'text-default-700 hover:bg-default-100'
            }`}
        >
            <span className={`flex h-5 w-5 items-center justify-center ${leadingIcon ? 'text-default-400' : 'text-transparent'}`}>
                {leadingIcon ?? <Circle className="h-3.5 w-3.5" />}
            </span>
            <span className="flex-1 truncate">{label}</span>
            <span className={`flex h-5 w-5 items-center justify-center ${isActive ? 'text-primary' : 'text-default-300'}`}>
                {isActive ? <CircleCheck className="h-4 w-4" /> : <Circle className="h-4 w-4" />}
            </span>
        </Link>
    );

    function CategoryComponent({categoryInfo}) {

        // Проверяем, существует ли parentSection и имеет ли он нужные свойства
        if (categoryInfo.breadcrumbs) {
            const items = categoryInfo.breadcrumbs.slice(0, -1).map((breadcrumb) => (
                <CategoryRow
                    key={breadcrumb.code}
                    href={`/shop/category/${breadcrumb.code}`}
                    label={breadcrumb.name}
                    leadingIcon={<ChevronLeft className="h-4 w-4" />}
                />
            ));

            if (!categoryInfo.isLeaf) {
                items.push(
                    <CategoryRow
                        key={categoryInfo.code}
                        href={`/shop/category/${categoryInfo.code}`}
                        label={categoryInfo.name}
                        isActive
                    />
                );
            }

            return items;
        }

        if (categoryInfo.parentCode && categoryInfo.name && categoryInfo.depthLevel !== "3") {
            return [
                <CategoryRow
                    key="parent"
                    href={`/shop/category/${categoryInfo.parentCode}`}
                    label={categoryInfo.parentName}
                    leadingIcon={<ChevronLeft className="h-4 w-4" />}
                />,
                <CategoryRow
                    key={categoryInfo.code}
                    href={`/shop/category/${categoryInfo.code}`}
                    label={categoryInfo.name}
                    isActive
                />,
            ];
        }

        if (categoryInfo.parentCode && categoryInfo.name && categoryInfo.depthLevel === "3") {
            return [
                <CategoryRow
                    key="parent"
                    href={`/shop/category/${categoryInfo.parentCode}`}
                    label={categoryInfo.parentName}
                    leadingIcon={<ChevronLeft className="h-4 w-4" />}
                />,
            ];
        }

        // Возвращаем null или другой компонент, если parentSection не существует или не содержит нужных данных
        return null;
    }

    const categoryParentInfo = CategoryComponent({categoryInfo});
    return (
        <>
            <div aria-label="Actions" className="flex flex-col gap-1">
                {categoryParentInfo}
                {allCategoryShop.map(category => (
                    <CategoryRow
                        key={category.id ?? category.code}
                        href={`/shop/category/${category.code}`}
                        label={category.name}
                        isActive={categoryInfo.code === category.code}
                    />
                ))}
            </div>
        </>
    );
}
